import { checkTwoDeviceCanConnect, getDeviceTypeLevels } from "@/commons/enums/model-type";
import { AddPlineCommand, BasicControl, BlockT, CURSOR_TYPE, DYMODE_MODE, FatLine, Line, LineSegments2, LineT, Listeners, MOUSE, ModelBase, PlineAttributes, Point, PrimitiveColor, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { Color, LineDashedMaterial, LineSegments, Plane, Vector3 } from "three";
import { DeviceComponentT } from "../models/DeviceComponentT";
import { CableT } from "../models/CableT";
import { DEVICEBASE_SINGAL } from "../enums/devicebase-singal";
import { DEVICE_CTRL_TYPE } from "../enums/control-type";




export class AssembleCableControl extends BasicControl {
    id = DEVICE_CTRL_TYPE.ASSEMBLE_CABLE;

    point_down: Point = new Point();
    point_move: Point = new Point();

    // pline所在的平面
    plinePlane: Plane = new Plane();
    // pline 头部的辅助移动线段区域
    helpLine: CableT;
    // pline 确定的区域
    pline: CableT;
    step: number = 1;
    loop: boolean = false; // 闭合
    orthogonalPoint: Vector3;
    capturePoint: Vector3;

    dymodeChoose: string = null;
    next: boolean = false; // 当前正在输入端点的属性值
    vertexIdx: number = 0; // 当前顶点

    // 绘制多段线命令, 因为画多段线的中途就需要创建，后续都是更新
    addPlineCmd: AddPlineCommand;

    currentLine: Line = new Line();
    // currentArc: Arc = new Arc();
    _startToCenter: Vector3 = new Vector3();
    _startToEnd: Vector3 = new Vector3();
    _tangentDir: Vector3 = new Vector3();
    _tangentDir_UCS: Vector3 = new Vector3();
    _aClockwise = false;
    currentAttribute: PlineAttributes = {
        bulge: 0,
        startWidth: 0,
        endWidth: 0,
    };
    //默认绘制Line 
    mode = 'L';

    needInit: boolean;
    globalCableId: number;
    layerUuid: string;
    // 第一个选中设备
    firstDevice: ModelBase;
    // 第二个选中设备
    secondDevice: ModelBase;
    // 输入的线宽
    inputRadius: number

    center: Point = new Point();

    options = [
        { name: '连接完成', key: 'C' },
        { name: '放弃', key: 'U' },
    ]
    polarPoint: Vector3;
    helpRayLine: LineT;
    normal: Vector3;
    origin: Vector3;
    axisX: Vector3;
    axisY: Vector3;
    axisZ: Vector3;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        /** 初始化 */
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.normal = this.context.ucsContext.getAxisList().axisZ.clone();
        this.origin = this.context.ucsContext.getAxisList().origin.clone();
        this.axisX = this.context.ucsContext.getAxisList().axisX.clone();
        this.axisY = this.context.ucsContext.getAxisList().axisY.clone();
        this.axisZ = this.context.ucsContext.getAxisList().axisZ.clone();
        this._tangentDir = this.context.ucsContext.getAxisList().axisX.clone();
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        /** 注册一些信号 */
        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        this.listeners.signals.onZoomChanged.add(this.onZoomChanged);
        this.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCable).add(this.onAssembleCable);
        // 第四步才禁止
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        /** 清空选择 */
        this.editor.selectControl.resetSelectedEntities();
        this.editor.clampControl.enabled = false
        /** 这里：提示选择1个设备图元 */
        this.listeners.signals.sendToDymodeTip.dispatch('选择第一个设备图元:');
        this.extraContext.stmodeContext.setStmode('选择第一个设备图元');
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        console.log('AssembleCableControl added')
    }

    // 二级控制器销毁
    dispose(): void {
        if (this.pline?.viewObj && !!this.pline?.viewObj?.parent) {
            this.pline.viewObj.parent.remove(this.pline.viewObj);
        }
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.onZoomChanged.remove(this.onZoomChanged);
        this.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCable).remove(this.onAssembleCable);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.clampControl.enabled = true
        let obj = this.helpLine?.viewObj;
        if (obj && !!obj.parent) {
            obj.parent.remove(obj);
        }
        console.log('AssembleCableControl removed')
    }

    onAssembleCable = (globalCableId: number, layerUuid: string) => {
        this.globalCableId = globalCableId;
        this.layerUuid = layerUuid;
        let initData = {
            globalCableId: globalCableId,
            layerUuid: layerUuid,
        }
        this.listeners.signals.setInitControlData.dispatch(initData);
    }

    // 初始化辅助线
    initHelpRayLine = () => {
        this.helpRayLine = new LineT();
        this.helpRayLine._isHelpLine = true;
        let viewObj: LineSegments | FatLine | LineSegments2 = this.helpRayLine.render();
        let size = this.context.renderContext.cameraEdge * this.context.renderContext.selectedDashScale * 5;
        viewObj.material = new LineDashedMaterial({ color: new Color('#00a500'), dashSize: size, gapSize: size });
    }

    initHelpLine = () => {
        this.currentLine = new Line();
        let curve = this.currentLine;
        this.helpLine = new CableT([curve], [{ ...this.currentAttribute }], this.plinePlane.normal);
        this.helpLine.color.set(PrimitiveColor.editColor);
        this.helpLine.lineWidth = this.inputRadius;
        this.helpLine.lineType = this.context.layerContext.getDrawingLineType();
        this.updateHelpLine(this.point_down, this.point_down);
        let view = this.helpLine.render();
        this.extraContext.sceneContext.scene.add(view);
    }

    updateHelpLine = (start: Point, end: Point) => {
        let attributes = this.helpLine.plineAttributes;
        if (this.mode === 'L') {
            // 直线
            if (!this.currentLine) {
                this.currentLine = new Line();
            }
            this.currentLine.set(start, end);
            this.currentAttribute.bulge = 0;
        }
        if (attributes.length > 0) {
            attributes[0] = { ...this.currentAttribute };
        }
        this.helpLine.updateViewGeometry();
    }

    onZoomChanged = (zoomScale) => {
        if (!this.helpRayLine?.viewObj) return;
        let size = this.context.renderContext.cameraEdge * this.context.renderContext.selectedDashScale * 5;
        let mat = <LineDashedMaterial>this.helpRayLine.viewObj.material;
        mat.dashSize = size;
        mat.gapSize = size;
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
        if (!point) {
            this.extraContext.sceneContext.scene.remove(this.helpRayLine?.viewObj);
        }
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    private _lastPointDown: Point = new Point();
    private _currentPointDown: Point = new Point();

    onPointerDown = (event) => {
        if (event.button !== MOUSE.LEFT) return;
        // 第4步才开始选择点
        if (this.step < 4) return;
        this._lastPointDown.copy(this.point_down.clone());

        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down);
        this._currentPointDown.copy(this.point_down.clone());
        if (this.orthogonalPoint) {
            this.point_down.copy(this.orthogonalPoint);
        }
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        if (this.polarPoint) {
            this.point_down.copy(this.polarPoint);
        }

        // 两个点相同，不创建
        if (this._lastPointDown.equals(this.point_down)) return;
        // 如果点了终点，则结束
        if (this.point_down.equals((this.secondDevice as DeviceComponentT).position.clone())) {
            this.updateHelpLine(this._lastPointDown, (this.secondDevice as DeviceComponentT).position.clone());
            this.updatePline();
            this.onCreateFinish();
        } else {
            this.updateHelpLine(this._lastPointDown, this.point_down);
            this.step_4();
        }
    }

    onPointerMove = (event) => {
        // 第四步才布置点
        if (this.step < 4) return;
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        if (this.orthogonalPoint) {
            this.point_move.copy(this.orthogonalPoint);
        }
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }

        if (this.point_move.equals(this.point_down)) return;
        this.updateHelpLine(this.point_down, this.point_move);

    }

    // 第一步 确认选择的图元是设备图元
    step_1 = () => {
        let selected = this.editor.selectControl.getSelectedEntityList()?.filter(entity => !entity.lock);
        if (selected?.length !== 1) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('能且仅能选中一个图元。请重新选择。');
            return;
        }
        let deviceEntity = selected[0];
        let level = getDeviceTypeLevels(deviceEntity.type);
        if (level === -1) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('需选中设备图元。请重新选择。');
            return;
        }
        this.firstDevice = deviceEntity;
        this.step = 2;
        this.listeners.signals.sendToDymodeTip.dispatch('选择第二个设备图元:');
        this.extraContext.stmodeContext.setStmode('选择第二个设备图元');
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        this.editor.selectControl.resetSelectedEntities();
    }

    // 第二步 确认选择的图元也是设备图元 并且存在关联关系 否则返回step1
    step_2 = () => {
        let selected = this.editor.selectControl.getSelectedEntityList()?.filter(entity => !entity.lock);
        if (selected?.length !== 1) {
            this.editor.selectControl.resetSelectedEntities();
            this.listeners.signals.sendToDymodeTip.dispatch('选择第二个设备图元:');
            this.extraContext.stmodeContext.pushLog('能且仅能选中一个图元。请重新选择。');
            return;
        }
        let deviceEntity = selected[0];
        let level = getDeviceTypeLevels(deviceEntity.type);
        if (level === -1) {
            this.editor.selectControl.resetSelectedEntities();
            this.listeners.signals.sendToDymodeTip.dispatch('选择第二个设备图元:');
            this.extraContext.stmodeContext.pushLog('需选中设备图元。请重新选择。');
            return;
        }
        let arr = checkTwoDeviceCanConnect(this.firstDevice, deviceEntity);
        if (arr?.length === 0) {
            this.editor.selectControl.resetSelectedEntities();
            this.listeners.signals.sendToDymodeTip.dispatch('选择第二个设备图元:');
            this.extraContext.stmodeContext.pushLog('两个设备无法连接。请重新选择。');
            return;
        }
        if (!!(arr[0] as DeviceComponentT)?.connected) {
            this.step = 1;
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('存在已连接上级的设备，无法连接。');
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        this.firstDevice = arr[0].clone();
        this.firstDevice.uuid = arr[0].uuid;
        this.secondDevice = arr[1].clone();
        this.secondDevice.uuid = arr[1].uuid;
        this.point_down.copy((this.firstDevice as BlockT).position);
        this._currentPointDown.copy(this.point_down.clone());
        this._dymodeActive = false;
        this.step = 3;
        this.listeners.signals.sendToDymodeTip.dispatch('输入线缆半径:');
        this.extraContext.stmodeContext.setStmode('输入线缆半径');
        this.extraContext.dymodeContext.enabled = true;
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.NUMBER);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK_CROSS);
        this.editor.selectControl.resetSelectedEntities();
    }

    // 第三步 输入线宽 线宽看着输入
    step_3 = () => {
        this.currentAttribute = {
            bulge: 0,
            startWidth: this.inputRadius,
            endWidth: this.inputRadius,
        }
        this.point_down.set(
            (this.firstDevice as DeviceComponentT).position.x,
            (this.firstDevice as DeviceComponentT).position.y,
            (this.firstDevice as DeviceComponentT).position.z
        )
        this.initHelpLine();
        this.initHelpRayLine();
        this.step = 4;
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.extraContext.dymodeContext.setDymodeTip("选择下一个点");
        this.extraContext.stmodeContext.setStmode('指定下一个点或', this.options);
    }

    // 第四步 不停的点选下一个点 下一个点 若点击到终点则绘制完成，结束命令
    step_4 = () => {
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        if (!this.pline) {
            this.createPline();
        } else {
            this.updatePline();
        }
        this._tangentDir.subVectors(this.currentLine.end, this.currentLine.start);
        this.currentAttribute.startWidth = this.currentAttribute.endWidth;
        this.listeners.signals.needRender.dispatch('redraw');
        this.listeners.signals.sendToDymodeTip.dispatch('指定下一个点:');
        this.extraContext.stmodeContext.setStmode('指定下一个点或', this.options);
        this.listeners.signals.needCapture.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.polarTracking.dispatch(this.point_down);
    }

    createPline = () => {
        this.pline = new CableT();
        this.pline._geoPlane.normal = this.context.ucsContext.getAxisList().axisZ;
        this.pline.axisX.copy(this.axisX);
        this.pline.plineAttributes.push({ ...this.helpLine.plineAttributes[0] });
        this.pline.plineAttributes.push({ ...this.helpLine.plineAttributes[0] });
        this.pline.setCurves([this.helpLine._geoCurves[0].clone()]);

        let view = this.pline.render();
        this.extraContext.sceneContext.scene.add(view);

    }

    updatePline = () => {
        if (!this.pline) return;
        let curves = [...this.pline._geoCurves, this.helpLine._geoCurves[0].clone()];
        this.pline.plineAttributes.pop();
        this.pline.plineAttributes.push({ ...this.helpLine.plineAttributes[0] })
        this.pline.plineAttributes.push({ ...this.helpLine.plineAttributes[0] })

        this.pline.setCurves(curves);
        this.pline.needRedraw = true;
        this.pline.updateViewGeometry();
        this.extraContext.listeners.signals.needRender.dispatch('redraw');
    }

    _dymodeActive = false;

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.point_down.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.DIST) {
            let dir = this.point_move.clone().sub(this.point_down).normalize();
            let end = dir.multiplyScalar(value.dist).add(this.point_down);
            this.point_down.set(end.x, end.y, end.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.CHOOSE) {
            let choose = value.choose.toUpperCase();
            this.dymodeChoose = choose;
            switch (choose) {
                case 'U':
                    // 放弃
                    this.onGiveUp();
                    break;
                case 'C':
                    // 结束
                    if (this.step === 4) {
                        // 算上正在移动的point_move
                        this.loop = true;
                        this.onKeyMouseConfirm();
                    }
                    break;
            }
        } else if (value.mode === DYMODE_MODE.NUMBER) {
            let number = value.number;
            if (this.step === 3) {
                this.inputRadius = number;
                this.step_3();
            }
        }
    }

    // 按下回车的回调
    onKeyMouseConfirm = () => {
        if (this.step === 1) {
            this.step_1();
        }
        else if (this.step === 2) {
            this.step_2();
        }
        else if (this.step === 3) {
            this.step_3();
        }
        else if (this.step === 4) {
            if (this._dymodeActive) {
                this._dymodeActive = false;
                // 两个点相同，不创建
                if (this._lastPointDown.equals(this.point_down)) return;
                // 如果输入终点，则结束
                if (this.point_down.equals((this.secondDevice as DeviceComponentT).position.clone())) {
                    this.updateHelpLine(this._lastPointDown, (this.secondDevice as DeviceComponentT).position.clone());
                    this.updatePline();
                    this.onCreateFinish();
                } else {
                    this.updateHelpLine(this._currentPointDown, this.point_down);
                    this._currentPointDown.copy(this.point_down.clone());
                    this.step_4();
                }

            } else if (this.loop) {
                this.updateHelpLine(this.point_down, (this.secondDevice as DeviceComponentT).position);
                if (!this.pline) {
                    this.createPline();
                } else {
                    this.updatePline();
                }
                this.onCreateFinish();
            } else {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            }
        }
    }

    // 按下放弃的回调
    onGiveUp = () => {
        this.editor.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    // 发送结束布置的信号，并结束二级控制器
    onCreateFinish = () => {
        // 防止dispose重复创建
        this.step = 0;
        let clone = this.pline.clone();
        clone.extraData = {
            globalCableId: this.globalCableId,
            firstDeviceUuid: this.firstDevice.uuid,
            secondDeviceUuid: this.secondDevice.uuid,
        }
        clone.layerUuid = this.layerUuid;
        let par = {
            addPris: [clone],
            firstDevice: this.firstDevice,
            secondDevice: this.secondDevice,
        }
        this.editor.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCableFinish).dispatch(par);
        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    initControl(data: any): void {
        if (!!data) {
            this.onAssembleCable(data.globalCableId, data.layerUuid);
        }
    }
}